import { render } from "./TopicItem.vue?vue&type=template&id=03ac5200"
import script from "./TopicItem.vue?vue&type=script&lang=js"
export * from "./TopicItem.vue?vue&type=script&lang=js"

import "./TopicItem.vue?vue&type=style&index=0&id=03ac5200&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__